export const getComputedScrollTop = (
  childNodes: any[] | NodeListOf<ChildNode> | null,
  nthIndex: number,
) => {
  let toScrollHeight = 0;

  if (!childNodes) {
    return toScrollHeight;
  }

  for (let i = 0; i < nthIndex; i += 1) {
    const element = childNodes[i];
    const height = parseFloat(
      getComputedStyle(element).getPropertyValue('height'),
    );
    toScrollHeight += height;
  }

  return toScrollHeight;
};
